import Color from '@styles/Color';
import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';

const MusicWaveIconWrap = styled.div<{
  color: string;
}>`
  display: flex;
  align-items: flex-end;
  position: relative;
  width: 15px;
  height: 15px;

  .bar {
    background-color: ${({ color }) => color || 'var(--textColor)'};
  }

  .bar1 {
    height: 6px;
  }

  .bar2 {
    height: 8px;
  }

  .bar3 {
    height: 10px;
  }

  .bar4 {
    height: 13px;
  }

  .bar5 {
    height: 15px;
  }

  &.on {
    .bar {
      animation: barAni 1.2s infinite;
    }

    .bar2 {
      animation-delay: 0.1s;
    }

    .bar3 {
      animation-delay: 0.2s;
    }

    .bar4 {
      animation-delay: 0.3s;
    }

    .bar5 {
      animation-delay: 0.4s;
    }
  }

  @keyframes barAni {
    0% {
      height: 4px;
    }
    50% {
      height: 14px;
    }
    100% {
      height: 4px;
    }
  }
`;

const Bar = styled.span`
  background-color: #fff;
  width: 1px;
  display: block;
  margin: 0 1px;
`;

function MusicWaveIcon({ isMusicOn, color }) {
  return (
    <MusicWaveIconWrap className={`${isMusicOn && 'on'}`} color={color}>
      <Bar className="bar bar1" />
      <Bar className="bar bar2" />
      <Bar className="bar bar3" />
      <Bar className="bar bar4" />
      <Bar className="bar bar5" />
    </MusicWaveIconWrap>
  );
}

export default MusicWaveIcon;
